import { combineReducers } from 'redux';

import sellerInfo, * as fromSellerInfo from './product/sellerInfo';
import offerInfo, * as fromOfferInfo from './product/offerInfo';
import shortUrlForm, * as fromShortUrlForm from './product/shortUrlForm';

const product = combineReducers({
  sellerInfo,
  offerInfo,
  shortUrlForm,
});

export default product;

export const getSellerAvatar = state =>
  fromSellerInfo.getSellerAvatar(state.sellerInfo);

export const getSellerUsername = state =>
  fromSellerInfo.getSellerUsername(state.sellerInfo);

export const getIsStoreEnabled = state =>
  fromSellerInfo.getIsStoreEnabled(state.sellerInfo);

export const getIsCartEnabled = state =>
  fromSellerInfo.getIsCartEnabled(state.sellerInfo);

export const getProductsInStore = state =>
  fromSellerInfo.getProductsInStore(state.sellerInfo);

export const getIsUserOwner = state =>
  fromSellerInfo.getIsUserOwner(state.sellerInfo);

export const getSellerFullName = state =>
  fromSellerInfo.getSellerFullName(state.sellerInfo);

export const getJoinedDate = state =>
  fromSellerInfo.getJoinedDate(state.sellerInfo);

export const getIsImagePortrait = state =>
  fromOfferInfo.getIsImagePortrait(state.offerInfo);

export const getIsOfferAvailable = state =>
  fromOfferInfo.getIsOfferAvailable(state.offerInfo);

export const getOfferErrorCode = state =>
  fromOfferInfo.getOfferErrorCode(state.offerInfo);

export const getImagePreview = state =>
  fromOfferInfo.getImagePreview(state.offerInfo);

export const getOfferTitle = state =>
  fromOfferInfo.getOfferTitle(state.offerInfo);

export const getOfferSlug = state =>
  fromOfferInfo.getOfferSlug(state.offerInfo);

export const getOfferPathname = state =>
  fromOfferInfo.getOfferPathname(state.offerInfo);

export const getOfferBasePrice = state =>
  fromOfferInfo.getOfferBasePrice(state.offerInfo);

export const getOfferMinPrice = state =>
  fromOfferInfo.getOfferMinPrice(state.offerInfo);

export const getOfferMaxPrice = state =>
  fromOfferInfo.getOfferMaxPrice(state.offerInfo);

export const getOfferDiscount = state =>
  fromOfferInfo.getOfferDiscount(state.offerInfo);

export const getOfferPriceBoost = state =>
  fromOfferInfo.getOfferPriceBoost(state.offerInfo);

export const getOfferDescription = state =>
  fromOfferInfo.getOfferDescription(state.offerInfo);

export const getOfferType = state =>
  fromOfferInfo.getOfferType(state.offerInfo);

export const getDigitalOfferInfo = state =>
  fromOfferInfo.getDigitalOfferInfo(state.offerInfo);

export const getEventOfferInfo = state =>
  fromOfferInfo.getEventOfferInfo(state.offerInfo);

export const getPhysicalOfferInfo = state =>
  fromOfferInfo.getPhysicalOfferInfo(state.offerInfo);

export const getIsProductCarted = state =>
  fromOfferInfo.getIsProductCarted(state.offerInfo);

export const getIsProductBeingCarted = state =>
  fromOfferInfo.getIsProductBeingCarted(state.offerInfo);

export const getIsCartable = state =>
  fromOfferInfo.getIsCartable(state.offerInfo);

export const getIsDirectCartable = state =>
  fromOfferInfo.getIsDirectCartable(state.offerInfo);

export const getOfferAffiliate = state =>
  fromOfferInfo.getOfferAffiliate(state.offerInfo);

export const getShortUrl = state =>
  fromShortUrlForm.getShortUrl(state.shortUrlForm);

export const getShortUrlForm = state => state.shortUrlForm;

export const getAddToCartErrors = state =>
  fromOfferInfo.getAddToCartErrors(state.offerInfo);

export const getCartedAmount = state =>
  fromOfferInfo.getCartedAmount(state.offerInfo);

export const getCartedAmountFormatted = state =>
  fromOfferInfo.getCartedAmountFormatted(state.offerInfo);

export const getLimitQuantity = state =>
  fromOfferInfo.getLimitQuantity(state.offerInfo);

export const getPurchasedQuantity = state =>
  fromOfferInfo.getPurchasedQuantity(state.offerInfo);



// WEBPACK FOOTER //
// ./src/product/reducers/ProductReducers.js